import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { getUnreadCount, subscribeUnreadCount } from './unreadStore';

const useStyles = makeStyles(theme => ({
  root: {
    minWidth: 20,
    height: 20,
    padding: '0 6px',
    borderRadius: 10,
    boxSizing: 'border-box',
    textAlign: 'center',
    fontFamily: theme.typography.fontFamily,
    fontSize: 12,
    fontWeight: 600,
    lineHeight: '20px',
    backgroundColor: theme.palette.error.main,
    color: theme.palette.error.contrastText
  }
}));

/**
 * "My Email work" menu entry count. Renders nothing when there is no unread notification.
 * Reads the shared value fed by NotificationBell; it does not poll.
 */
const UnreadMenuLabel = () => {
  const classes = useStyles();
  const [count, setCount] = useState(getUnreadCount());
  useEffect(() => {
    setCount(getUnreadCount());
    return subscribeUnreadCount(setCount);
  }, []);
  if (!count) return null;
  return <span className={classes.root}>{count > 99 ? '99+' : count}</span>;
};

export default UnreadMenuLabel;
